import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { ChancenEventlog } from './ChancenEventlog.js';

// Thanks xml...
export enum XAPIVerb {
  ANSWERED = 'http://adlnet.gov/expapi/verbs/answered',
  INTERACTED = 'http://adlnet.gov/expapi/verbs/interacted',
  ATTEMPTED = 'http://adlnet.gov/expapi/verbs/attempted',
  PROGRESSED = 'http://adlnet.gov/expapi/verbs/progressed',
}

@Entity()
export class XAPIScore extends AdornisEntity {
  public static override _class = 'XAPIScore';

  @Field(() => Float)
  public min!: number;
  @Field(() => Float)
  public max!: number;
  @Field(() => Float)
  public raw!: number;
  @Field(() => Float)
  public scaled!: number;
}

@Entity()
export class XAPIResult extends AdornisEntity {
  public static override _class = 'XAPIResult';

  @Field(() => Boolean)
  public completion!: boolean;
  @Field(() => String)
  public duration!: string;
  @Field(() => String)
  public response!: string;
  @Field(() => XAPIScore)
  public score!: XAPIScore;
  @Field(() => Boolean)
  public success!: boolean; // this should be what you are interested in
}

@Entity()
export class XAPIEventlog extends ChancenEventlog {
  public static override _class = 'XAPIEventlog';

  constructor(doc: PartialEntityData<XAPIEventlog>) {
    super(doc);
  }

  @Field(() => ID, {
    default: v => v ?? '',
  })
  public lessonID!: string;
  @Field(() => ID, {
    default: v => v ?? '',
  })
  public contentID!: string;
  @Field(() => ID, {
    default: v => v ?? '',
  })
  public h5pContentID!: string;
  @Field(() => String, {
    default: v => v ?? '',
  })
  public verb!: XAPIVerb;
  /** only set if verb === answered */
  @Field(() => XAPIResult)
  public XApiResult?: XAPIResult;

  @Field(() => Boolean, {
    default: v => v ?? false,
  })
  public result!: boolean;
}
